<template>
  <b>{{ display }}</b>
</template>
<script>
export default {
  name: 'DisplayEmpty',
  props: {
    length: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    display() {
      return ''.padStart(+this.length, '-')
    }
  }
}
</script>
